'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { List } from 'foundations-components/transitional/components/List';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import styled from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { CalloutTypes } from '../../constants/callout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CalloutTypeListItem = styled.div.withConfig({
  displayName: "CalloutTypeList__CalloutTypeListItem",
  componentId: "yuzn7x-0"
})(({
  theme
}) => `
  cursor: pointer;
  line-height: 1;

  &:hover,
  &:active {
    background-color: ${theme.color['fill-field-hover']};
  }
  `);
const propTypes = {
  calloutType: PropTypes.oneOf(Object.keys(CalloutTypes)),
  onClick: PropTypes.func.isRequired,
  paddingInline: PropTypes.string
};
function CalloutTypeList(props) {
  const {
    calloutType,
    onClick
  } = props;
  const {
    tokenProps
  } = filterTokenProps(props);
  return /*#__PURE__*/_jsx(List, {
    wrapChildren: true,
    children: Object.keys(CalloutTypes).map(type => {
      const {
        accentColor
      } = CalloutTypes[type];
      const isSelected = calloutType === type;
      const handleClick = () => {
        if (!isSelected) {
          onClick(type);
        }
      };
      return /*#__PURE__*/_jsx(CalloutTypeListItem, {
        children: /*#__PURE__*/_jsxs(TFlex, Object.assign({
          paddingBlock: "200",
          align: "center",
          onClick: handleClick,
          onMouseDown: evt => evt.preventDefault()
        }, tokenProps, {
          children: [/*#__PURE__*/_jsx(ColorSwatch, {
            color: accentColor,
            size: 10,
            selected: isSelected
          }), /*#__PURE__*/_jsx(View, {
            marginInlineStart: "200",
            as: "span",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `RichTextLib.callout.types.${type}`
            })
          })]
        }))
      }, type);
    })
  });
}
CalloutTypeList.propTypes = propTypes;
CalloutTypeList.displayName = 'CalloutTypeList';
export default CalloutTypeList;